import { render, staticRenderFns } from "./TitlePanel.vue?vue&type=template&id=4cfddf0b"
import script from "./TitlePanel.vue?vue&type=script&lang=ts"
export * from "./TitlePanel.vue?vue&type=script&lang=ts"
import style0 from "./TitlePanel.vue?vue&type=style&index=0&id=4cfddf0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports